/**
 * 
 * Routines utilisées pour des pages spécifiques
 * 
 * 
 * */

/**
 * affiche le modal des conditions
 */
function ShowConditions() {

    //Réactive le bodyscroll pour la fenetre des conditions
    if (isApple) {
        try {
            bodyScrollLock.enableBodyScroll(targetElement);
        } catch (e) {

        }

    }

    $('#ConditionsModal').modal('show');

    $('#ConditionsButtons').on('click', function () {

        //désactive le bodyscroll
        if (isApple)
        {
            try
            {
                bodyScrollLock.disableBodyScroll(targetElement);
            } catch (e)
            {

            }

        }

        $('#ConditionsModal').modal('hide');

    });

}
window.ShowConditions = ShowConditions;

/**
 * Lancé quand les préférences ont été exécuté pour vérifier si la session est expiré
 * @param {any} call
 */
function UpdatePrefComplete(call) {

    if (!IsSessionExpired(call))
    {
        CancelLoader();
        toastr.success(LBLSaveRappel, SUCCESSTitle);
        window.location.href = '/mes-preferences';
    }
}
window.UpdatePrefComplete = UpdatePrefComplete;


// pattern regex pour valider un numéro de téléphone
var patternTelephoneValide = /\(([0-9]{3})\)([ ])([0-9]{3})([-])([0-9]{4})/;
/**
 * vérifier le téléphone est dans un format valide
 * @param {any} telephone Numéro de téléphone
 * doublon dans le fichier CustomValidator.js car 
 */
function isTelephoneValide(telephone)
{
    return patternTelephoneValide.test(telephone);
}

/**
 * Affiche le panneau de droite avec les options de rappel
 * @param {any} url url à charger après l'exécution
 */
function ShowOptions(url) {

    ShowLoader();

    //Formattage du panneau latéral droit qui contiendra les options de rappel
    $('.rightPanel').velocity({
        translateX: '+100%'
    }, {
        complete: function (e) {

            RightPanelPos();
            $('.rightPanelControl1').hide();
            $('.rightPanelControl2').attr('style', 'display:flex !important');
            $('#rightPanelHeaderText').text(LBLRappel);
            $('.rightPanel').hide();
            ShowRDVSection('hide');

            //On cible le panneau latéral droit
            var div = $('.rightPanelContainer');

            // Charger la vue partielle
            getRappelPreferencesAsync(url).then(function (data) {

                // Charger le html
                div.empty();
                div.append(data);

                //Affiche le masque de fond
                $("#logoutBack").css('display', 'block');

                //Affiche le panneau
                $('.rightPanel').css('display', 'inline-block');

                //Appliquer le mask du téléphone à nouveau
                Inputmask(
                    {
                        "mask": "(999) 999-9999",
                        placeholder: " ",
                        showMaskOnFocus: false,
                        showMaskOnHover: false
                    }

                ).mask('.TelInputMask');

                var telephoneCellulaire = document.getElementById("TelephoneCellulaire");

                // Vérifie si nous avons deja un numéro de téléphone 
                var telephone = document.getElementById("TelephoneCellulaire");

                if (isTelephoneValide(telephone.value)) {
                    telephone.classList.add("complet");
                }
                else {
                    telephoneCellulaire.classList.remove("complet");
                    telephoneCellulaire.classList.add("invalid");
                }

                // Empêcher la touche Enter de bypasser la vérification cellulaire
                telephoneCellulaire.addEventListener('keydown', function () {
                    if (event.keyCode == 13) {
                        if (!SaveReminderRappelPanel()) {
                        event.preventDefault();
                        event.returnValue = false;
                        }
                    }
                });

                //Appliquer la verification jquerry du format du cellulaire a nouveau
                //Validation des numero de téléphone et cellulaire
                telephoneCellulaire.classList.remove("invalid");
                telephoneCellulaire.addEventListener('keyup', function () {

                    var spanCtrl = $('span[data-valmsg-for="TelephoneCellulaire"]')
                    var msgError = telephoneCellulaire.getAttribute("data-val-checkmobilephoneformat");
                    var saveButton = document.getElementById("saveRightPanel");
                    var rappelSMSNum = document.getElementById("RappelSMSNum");

                    //Affiche le message d'erreur et rend la ligne rouge
                    spanCtrl.text('');
                    telephoneCellulaire.classList.remove("invalid");
                    saveButton.setAttribute("form", "formOptions");
                    rappelSMSNum.style.display = "block";

                    if (!(isTelephoneValide(telephoneCellulaire.value)) /*&& RappelMediaID.value == 'SMS'*/) {

                        //rend le button d'enregistrement inactif
                        saveButton.setAttribute("form", "");
                        telephoneCellulaire.classList.add("invalid");
                        rappelSMSNum.style.display = "none";

                        //Affiche le message d'erreur et rend la ligne rouge
                        spanCtrl.text(msgError);
                    }
                });

                $('.rightPanel').velocity({
                    translateX: '0px'
                });

                CancelLoader();

            });
        }
    });
}
window.ShowOptions = ShowOptions;

/**
 * Vérifie si la sauvegarde du type de rappel est correct dans la page de préférences de communication
 * @param {any} RappelMediaID   Type de rappel
 * @param {any} RappelPeriodeID  Période de rappel
 */
function SaveReminder(RappelMediaID, RappelPeriodeID) {

    var telephoneCellulaire = document.getElementById("TelephoneCellulaire");

    // Empêcher un rappel par courriel (105) le jour même (102)
    if (RappelMediaID.value == 105 && RappelPeriodeID.value == 102) {
        toastr.error(ERRSaveEmail, ERRTitle);
        return false;
    }
    // Empêcher un rappel par SMS (106), le jour même (102) dont le numéro de téléphone est valide
    else if (RappelMediaID.value == 106 && RappelPeriodeID.value == 102 && isTelephoneValide(telephoneCellulaire.value)) {
        toastr.error(ERRSaveSMS, ERRTitle);
        return false;
    }

    return true;
}
window.SaveReminder = SaveReminder;

/**
 * Vérifie si la sauvegarde du type de rappel est correct dans la page des rendez-vous du donneur
 */
function SaveReminderRappelPanel() {

    var telephoneCellulaire = document.getElementById("TelephoneCellulaire");
    var telephoneCellulaireValide = isTelephoneValide(telephoneCellulaire.value);
    var spanCtrl = $('span[data-valmsg-for="TelephoneCellulaire"]')
    var msgError = telephoneCellulaire.getAttribute("data-val-checkmobilephoneformat");
    var saveButton = document.getElementById("saveRightPanel");
    var rappelSMSNum = document.getElementById("RappelSMSNum");

    var RappelMediaID = $('input[name="RappelMediaID"]:checked').val();
    var RappelPeriodeID = $('input[name="RappelPeriodeID"]:checked').val();

    // Empêcher un rappel par courriel (105) le jour même (102)
    if (RappelMediaID == 105 && RappelPeriodeID == 102)
    {
        toastr.error(ERRSaveEmail, ERRTitle);

        return false;
    }
    // Empêcher un rappel par SMS (106), le jour même (102) dont le numéro de téléphone est valide
    else if (RappelMediaID == 106 && RappelPeriodeID == 102 && telephoneCellulaireValide)
    {
        toastr.error(ERRSaveSMS, ERRTitle);

        return false;
    }
    // Empêche un rappel par SMS (106) dont le numéro de téléphone n'est pas valide.
    else if (RappelMediaID == 106 && !telephoneCellulaireValide) {

        // Empêcher le sauvegarde
        saveButton.setAttribute("form", "");

        // Indiquer que le cellulaire n'est pas valide
        telephoneCellulaire.classList.add("invalid");
        rappelSMSNum.style.display = "none";
        spanCtrl.text(msgError);
        telephoneCellulaire.focus();

        return false;
    }
    else
    {
        return true;
    }
    
}
window.SaveReminderRappelPanel = SaveReminderRappelPanel;

/**
 * Ferme le panneau latéral de droite
 * @param {Event} ev  Object event
 */
function CloseColDetail(ev) {

    //Si on as un événement, c'est du à un clic dans l'écran
    //si ca provient du panneau de droite on sort sinon on ferme le panneau
    if (ev != undefined) {

        if ($(ev.target).parents('.rightPanel').length) {
            return false;
        }
    }

    $("#logoutBack").css('display', 'none');

    $('.rightPanel').velocity({
        translateX: '+100%'
    }, {
        complete: function (e) {
            $('.rightPanel').hide();
        }
    });

}
window.CloseColDetail = CloseColDetail;

/**
 * Lorsqu'on clique sur un bouton pour afficher le détail d'un collecte dans Mes RDV et Ou Donner
 * @param {any} col     Code de collecte
 * @param {any} type    Type de don
 * @param {any} titre   Titre de la collecte
 * @param {any} dateDebut Date de début 
 * @param {any} dateFin Date de fin (plus utilisée)
 * @param {any} typeCol Type de collecte
 * @param {any} multiId Identifiant du multi jour
 * @param {any} NoShowRDVBtn Détermine si le bouton pour pendre un rendez-vous est affiché
 */
function OpenColDetail(col, type, titre, dateDebut, dateFin, typeCol, multiId, NoShowRDVBtn) {

    //Active le loader
    ShowLoader();

    //On met lasemaine en cours par défaut
    var now = moment();

    //on prend le dimanche de la semaine précédente
    var sunday = now.clone().add(-1, 'week').weekday(7).format('YYYY-MM-DD');

    //Le samedi de la semaine courante
    var saturday = now.clone().weekday(6).format('YYYY-MM-DD');

    //On applique la semaine courante dans le filtre par defaut
    filterApplied.WeekStartDate = sunday;
    filterApplied.WeekEndDate = saturday;

    //Selectionne la semaine 1 par défaut
    SelectWeek(1);

    //Trouve la couleur a appliqué selon le type de don
    typeColor = 'white';

    switch (type.toLowerCase()) {
        case 'sang':
            typeColor = '#ED1B24';
            break;
        case 'plaquettes':
            typeColor = '#FF7802';
            break;
        case 'plasma':
            typeColor = '#FFCC00';
            break;
        default:
    }

    //On cible le panneau latéral droit
    var div = $('.rightPanelContainer');

    //On charge la vue partielle dans le DIV obtenu
    div.load('/collecte/GetCollecteByCodePartial?collecteMultiJourID=' + multiId + '&typeFamillePrelevement=' + type, function () {

        //On cherche dans la matrice des distances si on a la collecte
        var dist = distances.find(x => x.code == col);

        //Si on l'a on affiche la distance
        if (dist != undefined) {
            $('#listDetailDistance').text(dist.dist);
        }

        $('.rightPanelControl2').attr('style', 'display:none !important');
        $('.rightPanelControl1').show();

        $('#ColDetailTakeRDV').off('click');

        $('#ColDetailTakeRDV').on('click', function () {
            CloseColDetail();
            OpenRDV(col, titre, type, dateDebut, typeCol, multiId);

        });

        //Affiche le masque de fond
        $("#logoutBack").css('display', 'block');

        if (NoShowRDVBtn == true) {

            NoRDVBtn = true;
            $('.rightPanelRDVBtn').attr('style', 'display: none !important;');

        } else {
            NoRDVBtn = false;

            $('.rightPanelRDVBtn').css('display', 'flex');
        }

        //Ajuste la panneau latéral droit selon la résolution
        RightPanelPos();

        //Affiche le panneau
        $('.rightPanel').css('display', 'inline-block');
        $('.rightPanel').velocity({
            translateX: '0px'
        });

        CancelLoader();

    });

}
window.OpenColDetail = OpenColDetail;

/**
 * Met la collecte préféré quand un utilisateur clique sur le bouton favori
 * @param {any} code    Code de collecte
 * @param {any} format  Format carte ou liste
 * @param {any} type    Type de don
 */
function SetCollectePref(code, format, type) {

    //si le format est vide on le trouve en regardant si le bouton liste est actif
    if (format == '') {
        if ($('.listBtn').hasClass('active')) {
            format = 'liste';
        } else {
            format = 'carte';
        }
    }

    Analytics('gaEvent', 'rendez-vous', 'centre favori', code);

    // Assigner le code de collecte préféré
    setCodeCollectePrefereAsync(code, type).then(function (data) {

            // Vider la cache, sinon on ne verra pas le code de collecte favori
            clearCollecteCache();

            //On recharge l'onglet une pour voir le résultat de la collecte favorite
            var tab = FindActiveTab();

        RenderTab(tab, format);

        CloseColDetail();
       
    })

}
window.SetCollectePref = SetCollectePref;


/**
 * Permet d'activer/désactiver les champs d'info donneur dans la page d'inscription si on clique
 * sur la case à cocher "Je suis un donneur"
 * */
function IsDonorChecked() {

    if ($('.IsDonorCheckBox').prop('checked')) {
        $('.RegisterDonorField').prop('disabled', false);
        $('.HQRegister .ui-datepicker-trigger').css('display', 'block');
    } else {
        $('.RegisterDonorField').prop('disabled', true);
        $('.HQRegister .ui-datepicker-trigger').css('display', 'none');
        $('.RegisterDonorField').val('');
    }

}
window.IsDonorChecked = IsDonorChecked;


/**
 * Permet d'activer ou désactiver les options de période de communication dans l'écran de préférence et le panneau de rappel
 * @param {any} RappelMediaID   Type de rappel
 */
function EnableRappelPeriode(RappelMediaID) {

    switch (RappelMediaID) {

        // Courriel
        case 'RadioRappelMedia105':
            // Activer ou désactiver les moments de rappel de rendez-vous
            DesactiverMomentsRappels(false, true, false);

            // Cacher la section qui demande le SMS
            AfficherOuCacherSectionDemanderCellulaire(false);
            break;

        // SMS
        case 'RadioRappelMedia106':
            // Activer ou désactiver les moments de rappel de rendez-vous
            DesactiverMomentsRappels(false, true, false);

            // Afficher la section qui demande le SMS
            AfficherOuCacherSectionDemanderCellulaire(true);

            // Retire la class invalid du champ cellulaire pour la premiere fois
            document.getElementById("TelephoneCellulaire").classList.remove("invalid");

            break;

        // Aucun
        case 'RadioRappelMedia999':
            // Activer ou désactiver les moments de rappel de rendez-vous
            DesactiverMomentsRappels(true, true, true);

            // Masquer la section qui demande le SMS
            AfficherOuCacherSectionDemanderCellulaire(false);
            break;

        // Téléphone et autre
        default:
            // Activer ou désactiver les moments de rappel de rendez-vous
            DesactiverMomentsRappels(false, false, false);

            // Masquer la section qui demande le SMS
            AfficherOuCacherSectionDemanderCellulaire(false);
            break;
    }
}
window.EnableRappelPeriode = EnableRappelPeriode;

/**
 * Activer ou désactiver les moments de rappel de rendez-vous
 * @param {any} veille   Détermine si le rappel la veille doit être actif
 * @param {any} jourMeme   Détermine si le rappel le jour même doit être actif
 * @param {any} troisJoursAvant   Détermine si le rappel trois jours avant doit être actif
 */
function DesactiverMomentsRappels(veille, jourMeme, troisJoursAvant) {
    // LaVeille
    document.getElementById("RadioRappelPeriode101").disabled = veille;
    // LeJourMeme
    document.getElementById("RadioRappelPeriode102").disabled = jourMeme;
    // TroisJoursAvant
    document.getElementById("RadioRappelPeriode103").disabled = troisJoursAvant;
}
window.DesactiverMomentsRappels = DesactiverMomentsRappels;

/**
 * Afficher ou cacher la section qui demande le cellulaire au donneur si SMS activé et cellulaire invalide
 * @param {any} verifierCellulaire   Si le numéro de cellulaire pourrait être affiché (vrai ou faux)
 */
function AfficherOuCacherSectionDemanderCellulaire(verifierCellulaire) {

    //montrer la section qui demande le cellulaire pour le SMS
    var sectionCellulaire = document.getElementById("numberSMS");
    var telephoneCellulaire = document.getElementById("TelephoneCellulaire");
    var saveButton = document.getElementById("saveRightPanel"); 

    // Afficher la section si cellulaire incomplet
    if (verifierCellulaire && !telephoneCellulaire.classList.contains("complet")) {    
        sectionCellulaire.style.display = "block"; // afficher
        saveButton.setAttribute("form", ""); // Empêcher la sauvegarde
        telephoneCellulaire.classList.add("invalid");
    }
    else {
        sectionCellulaire.style.display = "none"; // cacher
        saveButton.setAttribute("form", "formOptions"); // permettre la sauvegarde
    }
}
window.AfficherOuCacherSectionDemanderCellulaire = AfficherOuCacherSectionDemanderCellulaire;

/**
 * Retourne les préférences de rappel dans le panneau d'option
 * @param {any} url : url à charger après exécution, à retourner avec le modèle
 */
async function getRappelPreferencesAsync(url) {

    let httpRequestUrl = '/api/preference/GetRappelPreferences?url=' + encodeURI(url);

    return axios.get(httpRequestUrl)

        .then(function (response) {
            return Promise.resolve(response.data)
        })
        .catch(function (error) {
            console.log(error);
            if (error.response) {
                if (error.response.status = 203) {
                    window.location.href = '/user/mustbeloggedin';
                }
            }
            return Promise.reject(error);
        });
}
window.getRappelPreferencesAsync = getRappelPreferencesAsync;

/**
 * Permet d'assigner un code de collecte préféré
 * @param {any} code : Code de collecte préféré
 * @param {any} type : Retourne de l'informatin comme le type de prélèvement et si c'est en mode détail
 */
async function setCodeCollectePrefereAsync(codeCollecte, type) {

    ShowLoader();

    let httpRequestUrl = '/api/collecte/setcodecollecteprefere';

    return axios.put(httpRequestUrl, {
        codeCollecte: encodeURIComponent(codeCollecte),
        type: type
    },
        {
            headers: {
                RequestVerificationToken: $("[name='__RequestVerificationToken']").val()
            }
        })
        .then(function (response) {
            console.log(response);
            CancelLoader();
            return Promise.resolve(response.data);
        })
        .catch(function (error) {
            console.log(error);
            if (error.response) {
                if (error.response.status = 203) {
                    window.location.href = '/user/mustbeloggedin';
                }
            }
            return Promise.reject(error);
        });

}
window.setCodeCollectePrefereAsync = setCodeCollectePrefereAsync;

/**
 * Ferme le panneau des filtres
 * @param {Event} ev Evénement de l'objet
 */
function CloseFilter(ev) {

    //Si on a un événement, c'est dû à un clic dans l'écran
    //si ça provient du panneau de droite on sort sinon on ferme le panneau
    if (ev != undefined) {

        if ($(ev.target).parents('.rightPanel').length) {
            return false;
        }

    }

    CloseFilterSelectDate();

    $("#logoutBack").css('display', 'none');
    $('.filterPanel').velocity({
        translateX: '+100%'
    });

}
window.CloseFilter = CloseFilter;